import {REST_METHODS} from '@/src/app/constants/api';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const fetchCitiesDictionary = (stateId, clinicId) => {
  const requestMethod = getAuthorizationToken()
    ? authorizedFetch
    : unauthorizedFetch;

  const queryParams = [
    {
      name: 'state_id',
      value: stateId,
    },
  ];

  if (clinicId) {
    queryParams.push({
      name: 'clinic_id',
      value: clinicId,
    });
  }

  // @ts-ignore
  return requestMethod({
    method: REST_METHODS.GET,
    path: `/api/v1/job_portal/vacancies_filters/cities`,
    queryParams: queryParams,
  });
};

export default fetchCitiesDictionary;
